<template>
  <div class="page-container">
    <Header service-mode/>
     <main class="not-fund-container">
      <section class="content">
        <section class="left">
          <p class="oops">Oops…</p>
          <p class="text">404</p>
          <p class="desc">{{ $t('糟糕，小C今天心情不好，烦请刷新一下呢？再试试，试试就好了…') }}</p>
          <p class="back-home">
            <el-button @click="$router.push({ name: 'Home' })" type="primary">{{ $t('返回首页') }}</el-button>
          </p>
          <p class="reload-home">
            <img style="width:66px" src="~assets/image/404/finger.png" />
          </p>
        </section>
        <section class="right">
          <img style="width: 647px" src="~assets/image/404/cat.png" />
        </section>
      </section>
     </main>
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
export default {
  name: '404',
  data () {
    return {
    }
  },
  components: {
    Header
  }
}
</script>

<style lang="less" scoped>
.page-container {
  background-color: #F5F6FC;
  .not-fund-container {
    background-image: url(~assets/image/404/bg.png);
    background-size: cover;
    background-repeat: no-repeat;
    height: calc(100vh - 64px);
    display: flex;
    justify-content: center;
    .content {
      margin-top: 210px;
      width: 1010px;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: column;
        .oops {
          font-size: 36px;
          margin-top: 15px;
          font-weight: 300;
          color: #333752;
          line-height: 36px;
          letter-spacing: 5px;
        }
        .text {
          font-size: 108px;
          margin-top: 28px;
          font-family: MiSans-Demibold, MiSans;
          font-weight: 600;
          color: #333752;
          line-height: 108px;
          letter-spacing: 12px;
        }
        .desc {
          margin-top: 40px;
          width: 316px;
          height: 49px;
          font-size: 16px;
          font-weight: 300;
          color: #5A607F;
          line-height: 22px;
        }
        .back-home {
          margin-top: 40px;
        }
        .reload-home {
          width: 100px;
          text-align: center;
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
